import * as ko from 'knockout';
import * as localisationHelper from "localisationHelper";
import 'knockoutCustomBindings';
import 'localisationBindings';

import { JoinConfiguration } from 'Content/ts/Models/Join/JoinConfiguration';

// Services
import { ConfigurableTextService } from "Scripts/ts/Localisation/ConfigurableTextService";

// Components
import 'Content/ts/Shared/Inputs/Checkbox/input-checkbox-observable';
import 'Content/ts/Shared/ConfirmationModal/confirmation-modal';
import { registerComponent } from '@legend/knockout/util/component';

interface ITermsOfMembershipParams {
    JoinConfig: JoinConfiguration;
    ValidationFields: KnockoutObservable<any>[];
}

export const Deps = {
    LocalisationHelper: localisationHelper
};

export class TermsOfMembership {
    customMessages: {
        TermsAndConditionsTitle: string; 
        TermsAndConditionsPreamble: string; 
        TermsAndConditionsCheckboxLabel: string; 

        HealthDeclarationTitle: string; 
        HealthDeclarationPreamble: string;
        HealthDeclarationCheckboxLabel: string;
        
        TermsOfMembership: string;
        CloseButtonText: string;
    };

    configuration: JoinConfiguration;

    agreeTsAndCs: KnockoutObservable<boolean>;
    agreeHealthDeclaration: KnockoutObservable<boolean>;

    showHealthDeclarationModal: KnockoutObservable<boolean>;
    showTermsAndConditionsModal: KnockoutObservable<boolean>;
    showPrivacyPolicyModal: KnockoutObservable<boolean>;

    validationFields: KnockoutObservable<any>[];

    locationMessages: {
        TermsAndConditions: KnockoutObservable<string>;
        HealthDeclaration: KnockoutObservable<string>;
        DealsNewsAndPrivacyPreamble: KnockoutObservable<string>;
        PrivacyPolicy: KnockoutObservable<string>;
    };

    constructor(params: ITermsOfMembershipParams) {
        this.configuration = params.JoinConfig;
        this.validationFields = params.ValidationFields || [];

        this.agreeHealthDeclaration = ko.observable(false);
        this.agreeTsAndCs = ko.observable(false);

        this.showHealthDeclarationModal = ko.observable(false);
        this.showTermsAndConditionsModal = ko.observable(false);
        this.showPrivacyPolicyModal = ko.observable(false);
        this.locationMessages = {
            TermsAndConditions: ko.observable(null),
            HealthDeclaration: ko.observable(null),
            DealsNewsAndPrivacyPreamble: ko.observable(null),
            PrivacyPolicy: ko.observable(null)
        }

        // Initialisation Methods
        this.retrieveCustomMessages();

        this.configuration.facilityMainLocationId.subscribe(locationId => {
            this.retrieveLocationMessages(locationId);
        });
    }

    showHealthDeclaration() {
        this.showHealthDeclarationModal(true);
    }

    showTermsAndConditions() {
        this.showTermsAndConditionsModal(true);
    }

    showPrivacyPolicy() {
        this.showPrivacyPolicyModal(true);
    }

    private retrieveCustomMessages() {
        this.customMessages = {
            TermsAndConditionsTitle: Deps.LocalisationHelper.getString("JoinResources", "TermsAndConditionsTitle"),
            TermsAndConditionsCheckboxLabel: Deps.LocalisationHelper.getString("JoinResources", "TermsAndCondsPermission"),
            TermsAndConditionsPreamble: Deps.LocalisationHelper.getString("JoinResources", "TermsAndConditionsStatement")
                .replace('{0}', // replace the word Terms and Conditions with the localised equivalent and a link to the Terms and Conditions
                    '<a class="text-info" href="#" role="button" tabindex="0" data-bind="click: showTermsAndConditions"><span data-bind="text: customMessages.TermsAndConditionsTitle"></span></a>'),

            HealthDeclarationTitle: Deps.LocalisationHelper.getString("JoinResources", "HealthDeclarationTitle"),
            HealthDeclarationCheckboxLabel: Deps.LocalisationHelper.getString("JoinResources", "HealthDeclarationPermission"),
            HealthDeclarationPreamble: Deps.LocalisationHelper.getString("JoinResources", "HealthDeclarationStatement")
                .replace('{0}', // replace the word Health Declaration with the localised equivalent and a link to the health declaration
                    '<a class="text-info" href="#" role="button" tabindex="0" data-bind="click: showHealthDeclaration"><span data-bind="text: customMessages.HealthDeclarationTitle"></span></a>'),

            TermsOfMembership: Deps.LocalisationHelper.getString("JoinResources", "TermsOfMembership"),
            CloseButtonText: Deps.LocalisationHelper.getString("GenericResources", "Close")
        };
    };

    private retrieveLocationMessages(locationId: number) {
        if (locationId) {
            this.locationMessages.TermsAndConditions(ConfigurableTextService.RetrieveTextSync('webcopyOnlineSignupTerms', locationId));
            this.locationMessages.HealthDeclaration(ConfigurableTextService.RetrieveTextSync('OnlineSignupHealthDeclaration', locationId));
            this.locationMessages.PrivacyPolicy(ConfigurableTextService.RetrieveTextSync('webcopyOnlineSignupPrivacy', locationId));
            this.locationMessages.DealsNewsAndPrivacyPreamble(ConfigurableTextService.RetrieveTextSync('OnlineSignupDealsText', locationId)
                .replace('{0}', // replace the word Privacy Policy with the localised equivalent and a link to the privacy policy
                    '<a class="text-info" href="#" role="button" tabindex="0" data-bind="click: showPrivacyPolicy"><span data-bind="text: customMessages.PrivacyPolicyTitle"></span></a>'));
        }
    }
}

registerComponent("terms-of-membership", TermsOfMembership, require);